import firebase from 'firebase';
import { constants, Investor, InvestorKey, queries } from 'procura-shared';
import { messagedCall, post } from '.';

export const createInvestor = async (email: string) =>
  messagedCall(
    post('createInvestor', { email }),
    'createInvestorLoading',
    'createInvestorSuccess',
    'createInvestorError'
  );

export const updateInvestor = (investor: Investor): Promise<any> => {
  let newData = {};
  const keys = Object.keys(investor ?? {}) as InvestorKey[];
  for (const key of keys) {
    if (constants.INVESTOR_KEYS.includes(key) && !constants.STATIC_KEYS.includes(key)) {
      const value = investor[key];
      if (value == null || value === '') {
        newData = { ...newData, [key]: firebase.firestore.FieldValue.delete() };
      } else {
        newData = { ...newData, [key]: value };
      }
    }
  }
  if (Object.keys(newData).length === 0) return;
  return messagedCall(
    queries.investorQuery(investor.id).update(newData),
    'updateInvestorLoading',
    'updateInvestorSuccess',
    'updateInvestorError'
  );
};

export const deleteInvestor = (investorId: string) =>
  messagedCall(
    post('deleteInvestor', { investorId }),
    'deleteInvestorLoading',
    'deleteInvestorSuccess',
    'deleteInvestorError'
  );
